import axiosClient from './axiosClient';

export const getCompareQuotes = (dataParam?: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/quotes/api/quotes/comparison${dataParam}`;
    return axiosClient.get(url);
};
